module.exports = __webpack_public_path__ + "img/sv82.f57dbb6c.svg";